import React from 'react';

export const Button = ({ label = 'Submit', disabled = false, width = 'w-100' }) => {
  return (
    <button
      type="submit"
      className={`btn-dark-blue rounded-pill ${width}`}
      disabled={disabled}
    >
      {disabled ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Please wait...
        </>
      ) : (
        label
      )}
    </button>
  );
};
